import * as React from "react";
import { LoyaltyPoint } from "@grandvisionhq/fun-loyalty-points";
import { useGetCLLoyaltyPoints, useGetSolutionsLoyaltyPoints, useProductData } from "@grandvisionhq/fun-products";
import { useFeatureToggles, useIntl } from "@grandvisionhq/state";
const LoyaltyPointsCLContainer = () => {
  const { isLoyaltyPointsEnabled } = useFeatureToggles();
  const calculatedLoyaltyPoints = useGetCLLoyaltyPoints();
  const { getLabel } = useIntl();
  if (!isLoyaltyPointsEnabled || !calculatedLoyaltyPoints) return null;
  return /* @__PURE__ */ React.createElement(
    LoyaltyPoint,
    {
      loyaltySymbol: getLabel("products.loyalty.usp"),
      points: calculatedLoyaltyPoints,
      view: "usp"
    }
  );
};
const LoyaltyPointsSolutionsContainer = () => {
  const { isLoyaltyPointsEnabled } = useFeatureToggles();
  const calculatedLoyaltyPoints = useGetSolutionsLoyaltyPoints();
  const { getLabel } = useIntl();
  if (!isLoyaltyPointsEnabled || !calculatedLoyaltyPoints) return null;
  return /* @__PURE__ */ React.createElement(
    LoyaltyPoint,
    {
      loyaltySymbol: getLabel("products.loyalty.usp"),
      points: calculatedLoyaltyPoints,
      view: "usp"
    }
  );
};
const LoyaltyPointsGraphContainer = () => {
  const { isLoyaltyPointsEnabled } = useFeatureToggles();
  const { displayPrice } = useProductData();
  const { getLabel } = useIntl();
  if (!isLoyaltyPointsEnabled || !displayPrice.loyaltyPoints) return null;
  return /* @__PURE__ */ React.createElement(
    LoyaltyPoint,
    {
      loyaltySymbol: getLabel("products.loyalty.usp"),
      points: displayPrice.loyaltyPoints,
      view: "usp"
    }
  );
};
export {
  LoyaltyPointsCLContainer,
  LoyaltyPointsGraphContainer,
  LoyaltyPointsSolutionsContainer
};
//# sourceMappingURL=LoyaltyPointsGraphContainer.js.map
